import { render } from "./ContentContainer.vue?vue&type=template&id=17fcba85"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"
script.render = render

export default script